import type { RouteRecordRaw } from 'vue-router/auto'

// Routes
import defaultRoute from './routes'
import apps from './routes/apps'
import itineraries from './routes/itineraries'
import regional from './routes/regional'

// 👉 Redirects
export const redirects: RouteRecordRaw[] = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    name: 'index',
    redirect: to => {
      const isLoggedIn = useCookie<string | null | undefined>('_logged_in')

      if (isLoggedIn.value)
        return { name: 'itineraries-areas' }

      return { name: 'login', query: to.query }
    },
  },
]

export const routes: RouteRecordRaw[] = [
  ...defaultRoute,
  ...apps,
  ...itineraries,
  ...regional,
]
